import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Container, PageFade, Reveal } from "../components/site/Motion";
import { Pillars, WhyStruktiv, Parcours } from "../components/site/Sections";
import { ConsultationSection } from "../components/site/ConsultationSection";
import { SECTORS } from "../data/sectors";

const Hero = () => (
  <section className="wave-bg relative overflow-hidden" data-testid="home-hero">
    <Container className="grid items-center gap-12 py-14 lg:grid-cols-[1.05fr_1fr] lg:py-20">
      <Reveal className="space-y-7">
        <p className="eyebrow" data-testid="home-hero-eyebrow">La finance simplifiée</p>
        <h1 className="text-4xl leading-[1.06] sm:text-5xl lg:text-6xl">
          Des solutions concrètes pour <span className="text-[#650D23]">les professionnels</span> d'ici.
        </h1>
        <p className="max-w-xl text-lg leading-relaxed text-[#242020]/80">
          Protégez vos revenus, optimisez votre fiscalité et développez votre patrimoine grâce à des stratégies adaptées à votre réalité professionnelle.
        </p>
        <Link to="/secteurs" className="btn-primary" data-testid="home-hero-cta">
          Obtenez plus d'informations sur votre métier <ArrowRight className="h-4 w-4" />
        </Link>
      </Reveal>
      <Reveal delay={0.15} className="relative">
        <div className="absolute -left-6 -top-6 h-40 w-40 rounded-full bg-[#EDE3D9]" aria-hidden="true" />
        <img src="/img/beaute3.jpg" alt="Espace de soins esthétiques lumineux" className="relative aspect-[4/5] w-full rounded-[2.5rem] object-cover shadow-[0_40px_80px_-40px_rgba(74,12,27,.55)] sm:aspect-[5/5]" />
      </Reveal>
    </Container>
  </section>
);

const SectorPreview = () => (
  <Container className="pb-20">
    <div className="flex flex-wrap items-end justify-between gap-4">
      <Reveal><p className="eyebrow">Votre métier</p><h2 className="mt-4 text-3xl sm:text-4xl">Six secteurs, une même attention.</h2></Reveal>
      <Link to="/secteurs" className="btn-outline" data-testid="home-sectors-link">Voir les secteurs <ArrowRight className="h-4 w-4" /></Link>
    </div>
    <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
      {SECTORS.map((s, i) => (
        <Reveal key={s.slug} delay={i * 0.05}>
          <Link to={`/secteurs/${s.slug}`} data-testid={`home-sector-${s.slug}`} className="group block overflow-hidden rounded-2xl">
            <img src={s.cover} alt="" className="aspect-[3/4] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <p className="mt-3 font-display text-base leading-snug">{s.name}</p>
          </Link>
        </Reveal>
      ))}
    </div>
  </Container>
);

export default function Home() {
  return (
    <PageFade>
      <Hero />
      <Pillars />
      <WhyStruktiv />
      <Parcours />
      <SectorPreview />
      <ConsultationSection />
    </PageFade>
  );
}
